/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import localeDeDe from '@angular/common/locales/de';
import localeenGB from '@angular/common/locales/en-GB';
import { LocalDateValueAccessor } from 'angular-date-value-accessor';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { InputErrorPipe } from './em-common/input-error-pipe';
import { ConfigDataClass } from './em-common/config/config';
import { MatNativeDateModule } from '@angular/material/core';
import { PreloadFactory } from './preload-service.factory';

registerLocaleData(localeDeDe);
registerLocaleData(localeenGB);
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,LocalDateValueAccessor,
    BrowserAnimationsModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),TranslateModule.forRoot({
      defaultLanguage :ConfigDataClass.getLocalization(),
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    NbDatepickerModule.forRoot(),
    NbDateFnsDateModule.forRoot({ format:ConfigDataClass.getDateLocalization() }),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NgbModule,
    IonicModule.forRoot({}),
     FormsModule ,InputErrorPipe 
     
      
  ],
  bootstrap: [AppComponent],
  exports: [TranslateModule],
  providers: [ 
    HttpClient, 
    HttpClientModule, 
    
    { provide: LOCALE_ID, useValue: ConfigDataClass.getLocalization() },
    {
      provide: APP_INITIALIZER,
      deps: [
        ConfigDataClass
      ],
      multi: true,
      useFactory: PreloadFactory
    },
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],

 
})
export class AppModule {
}
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

